var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer has-background-white",class:{'has-background-black-ter': this.$root.$children[0].darkTheme}},[_c('div',{staticClass:"content has-text-centered"},[_c('p',{class:{'has-text-white-ter': this.$root.$children[0].darkTheme}},[_vm._v(" © TheLegend27 "+_vm._s(_vm.date)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }